import { useEffect, useState } from 'react';

import Flex from '@utilities/components/Layout/components/Flex';
import { HelpIcon, IconButtonV2 } from '@utilities';

import Narratives from '../Narratives';
import NarrativesCanvas from './components/NarrativesCanvas';
import NarrativesChatLandingPage from './components/NarrativesChatLandingPage';
import NarrativesChatWindow from './components/NarrativesChatWindow';
import NarrativesNavigation from './components/NarrativesNavigation';
import NarrativesTopicsWindow from './components/NarrativesTopicsWindow';

import { HELP_CENTER_BASE_URL } from '../Narratives/utilities/constants';

import styles from './_index.module.scss';

const NarrativesChat = () => {
  const [activePage, setActivePage] = useState('landing');
  const [flowId, setFlowId] = useState(null);
  const [draftFlowState, setDraftFlowState] = useState(null);
  const [initialInput, setInitialInput] = useState('');

  const isChat = activePage === 'chat';
  const isLanding = activePage === 'landing';
  const isTemplates = activePage === 'templates';
  const isTopics = activePage === 'topics';

  const hasActiveProject = Boolean(flowId) || Boolean(draftFlowState);

  const renderToolWindowContent = () => {
    if (isChat) {
      return (
        <NarrativesChatWindow
          initialInput={initialInput}
          onFlowSelected={setFlowId}
          onFlowStateChange={setDraftFlowState}
        />
      );
    }

    if (isTopics) {
      return <NarrativesTopicsWindow />;
    }

    return null;
  };

  useEffect(() => {
    if (!isLanding && !isTemplates) {
      document.body.classList.add('no-scroll');
    }

    return () => document.body.classList.remove('no-scroll');
  }, [isLanding, isTemplates]);

  useEffect(() => {
    if (isTopics && hasActiveProject) return;

    setFlowId(null);
    setDraftFlowState(null);
  }, [activePage]);

  return (
    <Flex className={styles['narratives-root']} gap="none">
      <NarrativesNavigation activePage={activePage} onClick={setActivePage} />
      {isLanding && (
        <NarrativesChatLandingPage onNavigation={setActivePage} onSubmit={setInitialInput} />
      )}

      {isTemplates && <Narratives />}

      {(isChat || isTopics) && (
        <div className={styles['narratives-chat-shell']}>
          <div className={styles['narratives-chat-content']}>
            <div className={styles['narratives-chat-window']}>{renderToolWindowContent()}</div>

            <div className={styles['narratives-chat-canvas']}>
              <NarrativesCanvas flowId={flowId} flowState={draftFlowState} />
            </div>
          </div>
        </div>
      )}

      {isLanding && (
        <IconButtonV2
          aria-label="Help"
          className={styles['help-button']}
          icon={<HelpIcon />}
          onClick={() => window.open(HELP_CENTER_BASE_URL, '_blank', 'noopener,noreferrer')}
          size="small"
          tooltip="Help"
          tooltipProps={{ placement: 'left' }}
          variant="subtle"
        />
      )}
    </Flex>
  );
};

export default NarrativesChat;
